import { bootstrap, showFailure } from './tgready/bootstrap';

void bootstrap()
  .then((context) => {
    if (context) return import('./index');
    return undefined;
  })
  .catch(showFailure);
